<template>
	<div class="turn-system">
		<div class="breadcrumb">
			<a-breadcrumb>
				<a-breadcrumb-item>
					<router-link to="/home">首页</router-link>
				</a-breadcrumb-item>
				<a-breadcrumb-item>总控设置</a-breadcrumb-item>
				<a-breadcrumb-item>{{currentBreadcrumb}}</a-breadcrumb-item>
			</a-breadcrumb>
		</div>
		<div class="page-content clearfix">
			<div class="page-left">
				<a-menu style="width: 251px"
						:openKeys="defaultMenu"
						:selectedKeys="selectedKeys"
						@click="handleMenuClick"
						:openKeys.sync="openKeys"
						:mode="mode"
						:theme="theme">
					<a-sub-menu v-auth="'1001'" key="1">
						<span slot="title">
							<router-link :to="{path:'/turn/user'}">
								<i class="iconfont icon-yonghuguanli icon-menu"></i>
								<span>用户管理</span>
							</router-link>
						</span>
						<a-sub-menu
								v-for="item2 in userMenuData"
								:key="'1-'+item2.deptId">
							<span slot="title">
								<router-link :to="'/turn/user?deptId=1-'+item2.deptId">
									<span>{{item2.deptName}}</span>
								</router-link>
							</span>
							<a-menu-item
									v-for="item3 in item2.children"
									:key="'1-'+item2.deptId+'-'+item3.deptId"
									:title="item3.deptName">
								<router-link
										:to="'/turn/user?deptId=1-'+item2.deptId+'-'+item3.deptId"
								>{{item3.deptName}}
								</router-link>
							</a-menu-item>
						</a-sub-menu>
					</a-sub-menu>
					<a-menu-item v-auth="'1002'" key="2"
					             :class="currenPath=='/turn/role'?'ant-menu-item ant-menu-item-selected':''">
						<router-link to="/turn/role">
							<i class="iconfont icon-jiaoseguanli icon-menu"></i>
							<span>角色管理</span>
						</router-link>
					</a-menu-item>
					<a-sub-menu v-auth="'1003'" key="3">
						<span slot="title">
							<router-link :to="{path:'/turn/dept'}">
								<i class="iconfont icon-zuzhijiagou icon-menu"></i>
								<span>组织机构</span>
							</router-link>
						</span>
						<a-menu-item
							v-for="item2 in deptMenuData"
							:key="'3-'+item2.deptId"
							:title="item2.deptName"
						>
							<router-link :to="'/turn/dept?deptType=3-'+item2.deptType+'&parentId='+item2.deptId">
								{{item2.deptName}}
							</router-link>
						</a-menu-item>
					</a-sub-menu>
					<a-sub-menu v-auth="'1005'" key="4">
						<span slot="title">
							<a-icon type="setting"/>
							<span>系统设置</span>
						</span>
						<a-menu-item v-auth="'1005'" key="7"
						             :class="currenPath=='/turn/group/patients'?'ant-menu-item ant-menu-item-selected':''">
							<router-link to="/turn/group/patients">患者分组设置</router-link>
						</a-menu-item>
						<a-menu-item v-auth="'1006'" key="8"
						             :class="currenPath=='/turn/auto/job'?'ant-menu-item ant-menu-item-selected':''">
							<router-link to="/turn/auto/job">自动作业设置</router-link>
						</a-menu-item>
						<a-menu-item v-auth="'1007'" key="9"
						             :class="currenPath=='/turn/early/warning'?'ant-menu-item ant-menu-item-selected':''">
							<router-link to="/turn/early/warning">预警设置</router-link>
						</a-menu-item>
						<a-menu-item  v-auth="'1008'" key="10"
						             :class="currenPath=='/turn/molecular/typing'?'ant-menu-item ant-menu-item-selected':''">
							<router-link to="/turn/molecular/typing">分子分型</router-link>
						</a-menu-item>
						<!--<a-menu-item key="7"-->
						<!--:class="currenPath=='/turn/basedb'?'ant-menu-item ant-menu-item-selected':''">-->
						<!--<router-link to="/turn/basedb">跟踪状态设置</router-link>-->
						<!--</a-menu-item>-->
						<!--<a-menu-item key="8"-->
						<!--:class="currenPath=='/turn/sample'?'ant-menu-item ant-menu-item-selected':''">-->
						<!--<router-link to="/turn/sample">样本类型设置</router-link>-->
						<!--</a-menu-item>-->
						<!--<a-menu-item key="9"-->
						<!--:class="currenPath=='/turn/ckpro'?'ant-menu-item ant-menu-item-selected':''">-->
						<!--<router-link to="/turn/ckpro">检查项目设置</router-link>-->
						<!--</a-menu-item>-->
					</a-sub-menu>
				</a-menu>
			</div>
			<div class="page-right">
				<router-view></router-view>
			</div>
		</div>
	</div>
</template>

<script>
  export default {
    data() {
      return {
        currentBreadcrumb: '',
        currenPath: '',
        mode: "inline",
        theme: "light",
        userMenuData: [],
        deptMenuData: [],
        defaultMenu: ["1"],
        selectedKeys: [],
        deptId: "",
        openKeys: ["1"]
      };
    },
    components: {},
    watch: {
      $route(val) {
        this.currentBreadcrumb = val.name;
        this.currenPath = val.path;
        if (this.currenPath != '/turn/role') {
          this.selectedKeys.length = 0;
        }
      },
      openKeys(val) {
      }
    },
    created() {
      this.currentBreadcrumb = this.$route.name;
      this.currenPath = this.$route.path;
      if (this.$route.path == '/turn/role') {
        this.defaultMenu = this.openKeys = [];
      } else if (this.$route.path == '/turn/dept') {
        this.defaultMenu = this.openKeys = ['3'];
			} else if (this.$route.path == '/turn/basedb' || this.$route.path == '/turn/sample' 
			|| this.$route.path == '/turn/ckpro' || this.$route.path == '/turn/group/patients'
			|| this.$route.path == '/turn/auto/job' || this.$route.path == '/turn/early/warning') {
        this.defaultMenu = this.openKeys = ['4'];
      } else {
        this.defaultMenu = this.openKeys = ["1"];
      }
    },
    mounted() {
      this.menuOpenKeys();
      this.getDeptTreeList();
    },
    methods: {
      handleMenuClick(e) {
        this.selectedKeys = [e.key];
      },
      getDeptTreeList() {
        this.$get("dept/findDeptTreeList").then(
          res => {
            this.deptMenuData = res.data.data;
            this.userMenuData = res.data.data;
          },
          err => {
            console.log("err", err);
          }
        );
      },
      menuOpenKeys() {
        if (this.$route.query.deptId) {
          let queryDeptId = this.$route.query.deptId
            ? this.$route.query.deptId.split("-")
            : [];
          this.setMenuOpenKeys(queryDeptId);
        } else if (this.$route.query.deptType) {
          let queryDeptId = this.$route.query.deptType
            ? this.$route.query.deptType.split("-")
            : [];
          this.setMenuOpenKeys(queryDeptId);
        }
      },
      setMenuOpenKeys(queryDeptId) {
        let newOpenKeys = [];
        for (let i = 0; i < queryDeptId.length; i++) {
          if (i == 0) {
            newOpenKeys.push(queryDeptId[i]);
          } else {
            newOpenKeys.push(newOpenKeys[i - 1] + "-" + queryDeptId[i]);
          }
        }
        if (queryDeptId.length > 0) {
          this.openKeys = newOpenKeys.slice(0, newOpenKeys.length - 1);
          this.selectedKeys = [newOpenKeys[newOpenKeys.length - 1]];
        }
      }
    }
  };
</script>

<style lang="scss">
	.turn-system {
		a:focus {
			text-decoration: none;
		}

		.icon-menu {
			vertical-align: middle;
			font-size: 20px;
			margin-right: 5px;
		}
	}

	.ant-menu-submenu .ant-menu-submenu-title a {
		display: block;
		color: rgba(0, 0, 0, 0.65);
	}
</style>